module.exports = __webpack_public_path__ + "static/media/si.fdc1ceea.svg";